import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Sidebar } from "../Sidebar/Sidebar";
import MainContent from "../MainContent/MainContent";
import "./Dashboard.css";
import { Header } from "../Header";
import { useGetConceptMetaDataQuery } from "../../store/api/lumi/concepts";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export const Dashboard = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const { id } = useParams();
    const { data: metaDataQu, isLoading } = useGetConceptMetaDataQuery(id);

    if (isLoading) {
        return (
            <Spin
                className={"spinner-by-center"}
                data-testid="loadingSpinner"
                indicator={<LoadingOutlined style={{ fontSize: 60 }} spin />}
            />
        );
    }
    return (
        <div
            className={`dashboard ${isSidebarOpen ? "dashboard-full-width" : ""}`}
        >
            <Sidebar
                isSidebarOpen={isSidebarOpen}
                setIsSidebarOpen={setIsSidebarOpen}
                metaDataQu={metaDataQu}
            />
            <div className="main-content">
                <Header />
                <MainContent
                    isSidebarOpen={isSidebarOpen}
                />
            </div>
        </div>
    );
};
